<template>
  <div
    class="h-screen bg-primary-blue text-white text-center q-pa-md grid place-content-center">
    <div>
      <div class="text-3xl mb-6 max-w-2xl text-center text-balance">
        <slot>
          {{ errorMessage ? $t(errorMessage) : '' }}
        </slot>
      </div>

      <template v-if="authStore.isAuth">
        <BaseButton
          v-if="isForbidden"
          class="q-mt-xl"
          color="primary"
          @click="$router.push('/')">
          {{ $t('Go Home') }}
        </BaseButton>
        <BaseButton
          v-else
          class="q-mt-xl"
          color="primary"
          @click="authStore.onLogout">
          {{ $t('Logout') }}
        </BaseButton>
      </template>
    </div>
  </div>
</template>

<script setup>
  import BaseButton from '@/components/UI/BaseButton.vue';
  import useAuthStore from '@/stores/authStore';
  const authStore = useAuthStore();
  const route = useRoute();
  const isForbidden = computed(() => route.query.error_code === '403');

  const errorMessage = computed(() => {
    const message = route.query.error || route.meta?.error;
    if (!message && isForbidden) {
      return 'error_forbidden';
    }
    return message;
  });
</script>
